import { localStoragesName } from 'src/models/enum/localStoragesName'
import { IInitialStateStoreUser } from './interfaces/InitialState'

export const initialUserStoreState: IInitialStateStoreUser = {
  token: sessionStorage.getItem(localStoragesName.token) || undefined,
  userType: sessionStorage.getItem(localStoragesName.userType),
}
